import React from 'react'
import img2029 from '../components/images/djiomart.png'
const events = () => {
    return (

        <>
            <div className="row  m-2">
                <img src={img2029} alt='jiomart' />
            </div>
            <div className="row m-2">
                <div className="col-sm ">

                    <h2 className='p-2'>JioMart Account Management Overview
                    </h2>
                    <p>JioMart Account Management offers streamlined services to boost your sales and optimize your presence on the platform. </p>
                </div>
                <div className="col-sm ">
                    {/* <img src={img201} alt='Queryimg' /> */}
                </div>
            </div>
            <ul >
                <h3 className='text-info'> Key Services We Offer:</h3>
                <li><b>•	Product Listing:</b> Create organized listings with accurate details and quality images to attract customers. </li>
                <li><b>•	Advertising Campaign:</b>Develop targeted ads to increase product visibility and drive sales. </li>
                <li><b>•	Brand Registry:</b>Assist in brand registration for IP protection and enhanced promotional tools. </li>
                <li><b>•	Brand Approval:</b> Guide you through the brand approval process to meet JioMart’s requirements.</li>
                <li><b>•	Category Approval:</b> Simplify the approval process for selling in restricted categories. </li>
                <li><b>•	Account Health:</b> Monitor account health to ensure compliance with JioMart’s policies. </li>
                <li><b>•	Order Processing:</b> Manage orders from confirmation to delivery efficiently. </li>
                <li><b>•	Payment Reconciliation:</b> Record transactions accurately and resolve discrepancies. </li>
                <li><b>•	Keyword Optimization:</b> Optimize keywords for listings and ads to improve search visibility.</li>
                <li><b>•	Safety Claim:</b> Handle product safety issues and ensure compliance.</li>
                <li><b>•	Basic Training:</b>Provide training to effectively manage your JioMart account. </li>
                <li><b>•	Sales Boost:</b> Implement strategies to increase sales through promotions and advertising.</li>
                <li><b>•	Deal Participation:</b>Facilitate participation in JioMart’s special deals to boost sales.</li>
            </ul>
        </>
    )
}

export default events